import { Outlet } from "react-router";

const AccountManagementPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default AccountManagementPage;
